import { COLOR, Icon as _Icon, mq, Heading as _Heading, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 32px;

  ${mq.sp} {
    margin-top: 16px;
  }
`;

export const BtnThumbnailWrapper = styled.button`
  display: block;
  position: relative;
  width: 224px;
  height: 126px;
  background-color: ${COLOR.GRAY200.code};
  border-radius: 8px;
  cursor: pointer;

  ${mq.sp} {
    width: 128px;
    height: 72px;
  }
`;

export const ImgSample = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
`;

export const DivIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);

  width: 56px;
  height: 56px;
  border: 4px solid ${COLOR.GRAY900.code};
  border-radius: 50px;

  ${mq.sp} {
    width: 48px;
    height: 48px;
  }
`;

export const Icon = styled(_Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
`;

export const Heading = styled(_Heading)`
  font-weight: ${FONT_WEIGHT.BOLD};
`;

export const SecTagRoot = styled.section`
  margin-left: 16px;

  ${mq.sp} {
    margin-left: 8px;
  }
`;
